/* eslint-disable @angular-eslint/prefer-inject */
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AbstractDataService, LoggerService } from '@pf/shared-services';
import { RequisitionsService } from '@control-tower/platform-wms';
import {
    EntityChangeTrackingDto,
    IChangesSearchParams,
    IPagedResult,
    PFWmsEntities,
} from '@pf/shared-common';
import { RequisitionStore } from './requisition.store';
import {
    RequisitionCreate,
    RequisitionRead,
    RequisitionSearchParams,
} from '../../entities/requisition.dto';
import { Operation } from 'fast-json-patch';

@Injectable()
export class RequisitionDataService extends AbstractDataService<
    RequisitionRead,
    RequisitionCreate
> {
    protected EntityName = PFWmsEntities.Requisition;
    constructor(
        private service: RequisitionsService,
        store: RequisitionStore,
        logger: LoggerService
    ) {
        super(store, logger);
    }
    protected createObs$(body: RequisitionCreate): Observable<RequisitionRead> {
        return this.service.requisitionCreate({
            requisitionViewModelCreateBody: body,
        }) as Observable<RequisitionRead>;
    }
    protected deleteObs$(id: string): Observable<RequisitionRead> {
        return this.service.requisitionDelete({
            id,
        }) as Observable<RequisitionRead>;
    }
    protected undoDeleteObs$(id: string): Observable<RequisitionRead> {
        return this.service.requisitionUndoDelete({
            id,
        }) as Observable<RequisitionRead>;
    }
    protected getObs$(id: string): Observable<RequisitionRead> {
        return this.service.requisitionReadById({
            id,
        }) as Observable<RequisitionRead>;
    }
    protected updateObs$(
        id: string,
        operations: Operation[]
    ): Observable<RequisitionRead> {
        return this.service.requisitionUpdatePatch({
            id,
            operation: operations,
        }) as Observable<RequisitionRead>;
    }
    protected searchObs$(
        searchParams: RequisitionSearchParams
    ): Observable<IPagedResult<RequisitionRead>> {
        return this.service.requisitionSearch(searchParams) as Observable<
            IPagedResult<RequisitionRead>
        >;
    }

    protected searchChangesObs$(
        searchParams: IChangesSearchParams
    ): Observable<IPagedResult<EntityChangeTrackingDto<RequisitionRead>>> {
        return this.service.requisitionGetChanges(searchParams) as Observable<
            IPagedResult<EntityChangeTrackingDto<RequisitionRead>>
        >;
    }
}
